import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Loader from '../../modules/layout/components/Loader';
import {IAxiosGetResponse, IInstitutionDto, IServiceDto} from '../../interfaces/IUtilities';
import {getById} from '../_request';
import {useTranslation} from 'react-i18next';
import {useToast} from '../../modules/layout/components/ToastContext';
import AppBreadcrumb from '../../modules/layout/components/AppBreadcrumb';
import BackButton from '../../modules/layout/components/BackButton';

const ServiceDetails = () => {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const { id } = useParams();
  const [service, setService] = useState({} as IServiceDto);
  const [institution, setInstitution] = useState({} as IInstitutionDto);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
        try {
            let result = await getById("/api/services/", id!);
            let respStatus = result?.status || result?.response.status;

            if (respStatus === 200) {
                setService(result.data as IServiceDto);
                setLoading(false);
            }
            else if (respStatus === 403) {
                navigate("/error/403");
            }
            else if (respStatus === 401) {
                navigate("/auth/login");
            }
            else if (respStatus === 500) {
                navigate("/error/500");
            }
            else {
                throw new Error(t('StatusCode', {code: String(respStatus)}));
            }
        } catch (error) {
            setLoading(false);
            console.log(t('ConnectionError', {error: String(error)}));
            showToast(t('ConnectionError', {error: String(error)}), 'error');
            navigate("/services/list");
        }
    }
    fetchData();
  }, [id]);

  const fetchInstitution = async (institutionId: string) => {
    try {
        let result = await getById("/api/institutions/", institutionId);
        let respStatus = result?.status || result?.response.status;

        if (respStatus === 200) {
            setInstitution(result.data as IInstitutionDto);
            setLoading(false);
        }
        else if (respStatus === 403) {
            navigate("/error/403");
        }
        else if (respStatus === 401) {
            navigate("/auth/login");
        }
        else if (respStatus === 500) {
            navigate("/error/500");
        }
        else {
            throw new Error(t('StatusCode', {code: String(respStatus)}));
        }
    } catch (error) {
        setLoading(false);
        console.log(t('ConnectionError', {error: String(error)}));
        showToast(t('ConnectionError', {error: String(error)}), 'error');
        navigate("/services/list");
    }
  }

  useEffect(() => {
      if (service?.id) {
          fetchInstitution(service.institutionId);
      }
  }, [service]);


  return (
    <div className="container mt-4 gg-container-card">
      <AppBreadcrumb 
        items={[
            { title: t("Home"), href: "/" },
            { title: t("Services"), href: "/services/list" },
            { title: `${service ? service.name : ""}: ${t("ServiceDetails")}` } // Active page (no href)
        ]} />

      <h3>{t("ServiceDetails")}</h3>
      
      {loading && (<Loader />)}
    
      <div className="card">
        <div className="card-header">
          <h4>{service.name}</h4>
        </div>
          <div className="card-body">
              <p><strong>{t('Code')}:</strong> {service.code}</p>
              <p><strong>{t('Institution')}:</strong> {institution.name}</p>
          </div>
          <div className="card-footer bg-transparent">
              <BackButton goTo={"/services/list"}/>

              <button className="btn gg-btn ms-3" onClick={() => navigate(`/services/edit/${service.id}`)}>
                  {t('Edit')}
              </button>
          </div>
      </div>

    </div>
  );
};

export default ServiceDetails;
